














import { computed, defineComponent, PropType, ref, toRefs, watch } from '@nuxtjs/composition-api'
import useSortMethod from '@/composables/use-sort-method'
import useFilterBarItem from '@/composables/use-filter-bar-item'

import SearchFilter, { SortMethod } from '@/classes/SearchFilter'
import GSelectMenu from '@/components/GSelectMenu.vue'
import { tdCarFilterPc } from '@/modules/ga4'

const { defaultSortMethod } = SearchFilter
export default defineComponent({
  props: {
    value: {
      type: String as PropType<SortMethod | null>,
      default: null,
    },
  },
  setup (props, { emit }) {
    const selectMenu = ref<InstanceType<typeof GSelectMenu> | null>(null)
    const active = computed(() => !!props.value)
    const { getSortMethodName, list } = useSortMethod()
    const selection = computed(() => getSortMethodName(props.value))
    const localValue = ref<SortMethod>(defaultSortMethod)

    const { isShow, show, hide } =
      useFilterBarItem(toRefs(props).value, emit)

    watch(
      () => props.value,
      (value) => { if (value) localValue.value = value },
      { immediate: true }
    )

    const save = (e: SortMethod | null) => {
      emit('input', e ?? defaultSortMethod)
    }

    const clickItem = (e: SortMethod) => {
      save(e)

      tdCarFilterPc({
        sort: getSortMethodName(e),
      })
    }

    const showMenu = () => {
      selectMenu.value?.show()
      show()
    }

    return {
      active,
      selection,
      localValue,
      list,

      isShow,
      show,
      hide,

      selectMenu,
      showMenu,
      clickItem,
    }
  },
})
